import { OnInit, OnDestroy, Directive } from '@angular/core';
import { fromEvent, merge, Subject, timer } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
// @ts-ignore
import { CommandManager } from '@wondavrspaces/resource';
import { debounce, map, takeUntil, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

@Directive({})

export abstract class BaseShortcut implements OnInit, OnDestroy {
  private _destroy: Subject<any>;

  constructor() {}

  ngOnInit(): void {
    this._bindKeyPress().subscribe(this.onKeyPress.bind(this));
  }

  ngOnDestroy(): void {
    this._destroy.next();
  }

  // Override this method to handle keypress behavior
  onKeyPress($event: KeyboardEvent): void {}

  // Override this method to prevent default handling of event
  filterEvent(event: any): void {}

  _unbindKeyPress(): void {
    if (!this._destroy) {
      return;
    }

    this._destroy.next();
    this._destroy = null;
  }

  _bindKeyPress(): Observable<any> {
    this._unbindKeyPress();
    this._destroy = new Subject();
    return fromEvent(window, 'keydown')
      .pipe(
        tap(this.filterEvent.bind(this)),
        debounce(() => timer(100)),
        // We map answer to KeyboardEvent, typescript strong typing...
        map(state => (state as KeyboardEvent)),
        takeUntil(this._destroy)
      );
  }
}
